<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Faktury - legacy</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Faktury - legacy</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox">
          <div class="ibox-title" @click="isFiltersOpen = !isFiltersOpen">
            <h5>Filtry</h5>
            <span :class="chevronFiltersClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content flex" v-show="isFiltersOpen">
            <div class="col-md-3 nopadding">
              <div class="form-group">
                <label class="control-label col-sm-3">Wybierz daty</label>
                <div class="col-sm-8">
                  <VueDatePicker
                    class="stats-daterangepicker2"
                    v-model="filterRangeDate"
                    multi-calendars
                    :format="format"
                    range
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isMainOpen = !isMainOpen">
            <h5>Faktury - legacy</h5>
            <span :class="chevronMainClass" class="ibox-toggle"></span>
          </div>
          <div class="ibox-content" v-show="isMainOpen">
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @click="isSearch = false"
                      @change="setRowsPerPage"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :loading="loading"
                  alternating
                  multi-sort
                  show-index
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>

                  <template #item-actions="item">
                    <button
                      @click="getInvoicePdf(item)"
                      class="btn btn-primary btn-xs"
                      title="Pobierz PDF"
                    >
                      <i class="fa fa-file"></i>
                    </button>
                  </template>

                  <template #item-client_email="item">
                    <router-link
                      v-if="canViewClients"
                      :to="'/clients/' + item.client_pk"
                    >
                      {{ item.client_email }}
                    </router-link>
                    <span v-else>{{ item.client_email }}</span>
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import { clientPermissionsConst } from "../../constants/clientConstants";
export default {
  name: "LegacyInvoicesList",
  mixins: [],
  components: {},
  props: {},

  setup() {
    const store = useStore();
    const invoicesData = computed(() => store.getters.getInvoicesData);
    // The client column links to the client details view.
    const canViewClients = computed(() =>
      hasPermission(clientPermissionsConst.view)
    );

    let headers = [
      { text: "Nr faktury", value: "number", sortable: true, search: true },
      { text: "Nr zamówienia", value: "order", sortable: true, search: true },
      { text: "Email", value: "client_email", sortable: true, search: true },
      {
        text: "Nazwa firmy",
        value: "company_name",
        sortable: true,
        search: true,
      },
      {
        text: "Sklep",
        value: "company_localization_display",
        sortable: true,
        search: true,
      },
      { text: "Język", value: "lang_display", sortable: true, search: true },
      { text: "Waluta", value: "currency", sortable: true, search: true },
      { text: "Netto", value: "net_price", sortable: true, search: true },
      { text: "VAT", value: "vat", sortable: true, search: true },
      { text: "Brutto", value: "gross_price", sortable: true, search: true },
      {
        text: "Rodzaj faktury",
        value: "invoice_type_display",
        sortable: true,
        search: true,
      },
      {
        text: "Data wystawienia",
        value: "issue_date",
        sortable: true,
        search: true,
      },
      { text: "Akcje", value: "actions" },
    ];

    let items = ref([]);
    let itemsAll = ref(0);
    const formatGroups = ref([]);
    const showModal = ref(false);
    const loading = ref(true);
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const filtersMonth = ref();
    const filterRangeDate = ref();
    const isFiltersOpen = ref(true);
    const isMainOpen = ref(true);

    const chevronFiltersClass = computed(() =>
      isFiltersOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronMainClass = computed(() =>
      isMainOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );

    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
    });

    const getInvoices = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }

      await store.dispatch("getLegacyInvoices", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        search: searchValue.value,
        date: filterRangeDate.value,
      });
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getInvoices();
          isSearch.value = false;
        }, 1000);
      }
    };

    const resetFilters = () => {
      searchValue.value = {};
      filterRangeDate.value = [];
      serverOptions.value.sortBy = "";
      getInvoices();
    };

    const updateSort = () => {
      search.value = true;
    };

    const format = (date) => {
      let day, month, year, dayEnd, monthEnd, yearEnd;
      if (date[0]) {
        day = date[0].getDate();
        month = date[0].getMonth() + 1;
        year = date[0].getFullYear();
      }

      if (date[1]) {
        dayEnd = date[1].getDate();
        monthEnd = date[1].getMonth() + 1;
        yearEnd = date[1].getFullYear();
      }

      if (date.length > 1) {
        return `${day}/${month}/${year} - ${dayEnd}/${monthEnd}/${yearEnd}`;
      }
    };

    const getInvoicePdf = (item) => {
      store.dispatch("getInvoicePdf", {
        pk: item.order,
        type: item.invoice_type,
      });
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("invoicesLSearchValue") !== null) {
        searchValue.value = localStorage.getItem("invoicesLSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }

      if (
        localStorage.getItem("lInvoicesRangeDate") !== null &&
        localStorage.getItem("lInvoicesRangeDate") !== "undefined" &&
        localStorage.getItem("lInvoicesRangeDate") !== undefined
      ) {
        filterRangeDate.value = localStorage.getItem("lInvoicesRangeDate");
        filterRangeDate.value = JSON.parse(filterRangeDate.value);
      }

      getInvoices();
    });

    watch(
      () => [searchValue.value, filterRangeDate.value],
      function () {
        localStorage.setItem(
          "invoicesLSearchValue",
          JSON.stringify(searchValue.value)
        );
        localStorage.setItem(
          "lInvoicesRangeDate",
          JSON.stringify(filterRangeDate.value)
        );
        getInvoices();
      }
    );

    watch(
      () => invoicesData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getInvoices();
          isSearch.value = false;
        }
      }
    );

    return {
      headers,
      items,
      itemsAll,
      loading,
      canViewClients,
      serverOptions,
      showModal,
      searchValue,
      search,
      resetFilters,
      updateSort,
      isSearch,
      rowsPerPage,
      formatGroups,
      getInvoicePdf,
      format,
      filtersMonth,
      selectPage,
      setRowsPerPage,
      filterRangeDate,
      isFiltersOpen,
      isMainOpen,
      chevronFiltersClass,
      chevronMainClass,
    };
  },
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}
</style>
